import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import CategoryCard from '../components/home/CategoryCard';
import HomeSlider from '../components/HomeSlider';
import HomeProductSlider from '../components/HomeProductSlider';
import { callGetWebservice } from '../hooks/api';
import { setUser } from '../store/reducers/auth';
import { setItemCategories } from '../store/reducers/general';
import { userData } from '../utils/constants';
import { getFromLocalStorage } from '../utils/localStorageUtils';
import { Helmet } from 'react-helmet-async';
import Skeleton from '../components/common/Skeleton';
import '../assets/css/styles.css';

const Home = () => {

    const [banners, setBanners] = useState([]);
    const [categories, setCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState({
        banners: true,
        categories: true,
        products: true
    });

    const dispatch = useDispatch();

    let data = getFromLocalStorage(userData);
    if (data) {
        dispatch(setUser(data));
    }

    useEffect(() => {
        let requestPacket = {};
        callGetWebservice('banners', requestPacket, (response) => {
            handleBannerWebservice(response);
        });

        requestPacket = {};
        callGetWebservice('item-categories', requestPacket, (response) => {
            handleItemCategoriesWebservice(response);
        });

        requestPacket = {};
        callGetWebservice('my-items', requestPacket, (response) => {
            handleItemsWebservice(response);
        });

    }, []);


    const handleBannerWebservice = (response) => {
        setBanners(response.data);
        setLoading(prev => ({ ...prev, banners: false }));
    }

    const handleItemCategoriesWebservice = (response) => {
        dispatch(setItemCategories(response.data));
        const filteredData = response.data?.filter(cat => cat.id !== 0);
        setCategories(filteredData);
        setLoading(prev => ({ ...prev, categories: false }));
    }

    const handleItemsWebservice = (response) => {
        setProducts(response.data);
        setLoading(prev => ({ ...prev, products: false }));
    }

    const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

    return (
        <>
            <Helmet>
                <title>Online Store | Premium Shopping &amp; Lifestyle</title>
                <meta name="description" content="Discover premium fashion, trendy collections, and quality products. Fast delivery, secure checkout, and best prices guaranteed." />
                {currentOrigin && <link rel="canonical" href={`${currentOrigin}/`} />}
                <meta property="og:title" content="Online Store | Premium Shopping &amp; Lifestyle" />
                <meta property="og:description" content="Discover premium fashion, trendy collections, and quality products. Fast delivery, secure checkout, and best prices guaranteed." />
                {currentUrl && <meta property="og:url" content={currentUrl} />}
            </Helmet>

            {/* ============================ Hero Banner  Start================================== */}
            {loading.banners ? (
                <div className="container py-4">
                    <Skeleton height="70vh" borderRadius="24px" />
                </div>
            ) : (
                <HomeSlider banners={banners} />
            )}
            {/* ============================ Hero Banner End ================================== */}

            {/* ======================= Trending Categories ======================== */}
            <section className="bg-white">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
                            <span className="text-primary font-heading fs-xs ls-2 text-uppercase d-block mb-2">Discovery</span>
                            <h2 className="font-heading text-uppercase ls-1 display-5">Trending Categories</h2>
                        </div>
                    </div>
                    <div className="row">
                        {loading.categories ? (
                            [1, 2, 3, 4, 5, 6].map((i) => (
                                <div key={i} className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-4">
                                    <Skeleton height="180px" borderRadius="24px" />
                                </div>
                            ))
                        ) : (
                            categories.map((category, index) => (
                                <div key={'category-' + index} className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6">
                                    <CategoryCard category={category} />
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </section>
            {/* ======================= Trending Categories End ======================== */}

            {/* ======================= Products List ======================== */}
            <section className="middle">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div className="sec_title position-relative text-center">
                                <h2 className="font-heading text-uppercase ls-1 display-5 mb-4">Our Trending Products</h2>
                            </div>
                        </div>
                    </div>
                    {/* row */}
                    <div className="row align-items-center rows-products">
                        {loading.products ? (
                            <div className="row w-100">
                                {[1, 2, 3, 4].map((i) => (
                                    <div key={i} className="col-xl-3 col-lg-4 col-md-6 col-6 mb-4">
                                        <Skeleton height="350px" borderRadius="24px" />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            products && <HomeProductSlider products={products?.data} />
                        )}
                    </div>
                    {/* row */}
                    {!loading.products && products.total > 8 && <div className="row justify-content-center mt-4">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <Link to={'/productlist'}>
                                <div className="position-relative text-center">
                                    <span className="btn-fine btn-primary-fine px-5">Explore More</span>
                                </div>
                            </Link>
                        </div>
                    </div>}

                </div>
            </section>
            {/* ======================= Product List ======================== */}
        </>
    )
}

export default Home